import { lazy, Suspense } from "react";
import { useExitIntent } from "@/hooks/useExitIntent";

const SlideInForm = lazy(() => import("@/features/marketing/SlideInForm"));

export function GlobalExitIntent() {
    const { showExitIntent, closeExitIntent } = useExitIntent();

    return (
        <Suspense fallback={null}>
            <SlideInForm isOpen={showExitIntent} onClose={closeExitIntent} />
        </Suspense>
    );
}
